/**
 * Calculate BXGY (Buy X Get Y) quantity
 * User selects TOTAL quantity they want, system calculates paid/free
 * Quantity can start from 1, no minimum requirement
 * IMPORTANT: Only 1 item is free maximum, regardless of quantity
 *
 * @param {Object} coupon - Coupon object with BuyItemCount and GetItemCount
 * @param {number} totalQtyWanted - Total quantity user wants (paid + free)
 * @returns {Object} - { paidQuantity, freeQuantity, totalQuantity, canApply, setSize }
 */

import { getBuyItemCount, getGetItemCount } from './types';

function calculateBXGYQuantity(coupon, totalQtyWanted) {
  const BuyItemCount = getBuyItemCount(coupon);
  const GetItemCount = getGetItemCount(coupon);

  // Set size = how many items in one complete set (paid + free)
  const setSize = BuyItemCount + GetItemCount;

  // No minimum requirement - quantity can start from 1
  // IMPORTANT: Only 1 item is free maximum, regardless of quantity
  // If user selects 4 qty in Buy 1 Get 1, only 1 is free, 3 are paid
  
  // Check if we can apply the free item (need at least BuyItemCount + 1 to get 1 free)
  const canApply = totalQtyWanted >= (BuyItemCount + 1);
  
  // Only 1 item is free, rest are paid
  const freeQuantity = canApply ? 1 : 0;
  const paidQuantity = totalQtyWanted - freeQuantity;
  const totalQuantity = totalQtyWanted; // User's selected quantity

  return {
    paidQuantity, // What user pays for
    freeQuantity, // Free items (always 0 or 1)
    totalQuantity, // Total items (equals totalQtyWanted)
    canApply, // True if quantity >= BuyItemCount + 1
    setSize,
    BuyItemCount,
    GetItemCount,
  };
}

export default calculateBXGYQuantity;
